import { render, staticRenderFns } from "./VerConsultorio.vue?vue&type=template&id=edb1f6fa"
import script from "./VerConsultorio.vue?vue&type=script&lang=js"
export * from "./VerConsultorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports